import { TranslateModule } from '@ngx-translate/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ToastMessage } from '../../models/toast-message.interface';
import { ToasterService } from '../../services/toaster.service';
import { ButtonComponent } from '../button/button.component';
import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
  selector: 'lib-toaster',
  imports: [CommonModule, IconButtonComponent, TranslateModule, ButtonComponent],
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  animations: [
    trigger('toastAnim', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' })),
      ]),
    ]),
  ],
})
export class ToasterComponent {
  private toasterService = inject(ToasterService);

  // Use the signal from the service
  toasts = this.toasterService.toasts;

  removeToast(toastId: number): void {
    this.toasterService.removeToast(toastId);
  }

  getProgressStyle(toast: ToastMessage): { animationDuration: string } {
    const duration = toast.duration ?? 4000;
    return { animationDuration: `${duration}ms` };
  }

  handleActionClick(toast: ToastMessage) {
    if (toast.action && toast.action.callback) {
      toast.action.callback();
      this.removeToast(toast.id); // Remove toast after action
    }
  }
}
